export default __webpack_public_path__ + "static/media/logout.c557ea60.svg";